module.exports = __webpack_public_path__ + "static/img/can-citrus-cherry.91f84a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cans/can-citrus-cherry.png
// module id = qX2e
// module chunks = 0